export default "__VITE_ASSET__48767ba9__"